import request from "@/utils/request";

export function userFeedback(data) {
  return request({
    url: "/fleet/questionnaire_info/user/feedback",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data
  })
}

export function userBecome(params) {
  return request({
    url: "/fleet/user/become/invalid/token",
    method: "get",
    params
  })
}

export function emailBuriedPoint(params) {
  return request({
    url: "/fleet/check/email/count",
    method: "get",
    params
  })
}
